import React from 'react';
import LogoFreya from 'src/assets/images/new-logo-freya.svg';
import {
  GridPatternTopLeft,
  GridPatternBottomRight,
  SpotlightTopLeft,
  SpotlightBottomRight,
  AnimatedBorder,
} from 'src/presentations/components/atom/icons/tour-guide';

interface TourWelcomeModalProps {
  isOpen: boolean;
  onStart: () => void;
  onSkip: () => void;
}

export const TourWelcomeModal: React.FC<TourWelcomeModalProps> = ({ isOpen, onStart, onSkip }) => {
  if (!isOpen) return null;

  return (
    <>
      <style>{`
                @keyframes tour-fade-in {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes tour-draw-border {
                    to { stroke-dashoffset: 0; }
                }

                @keyframes tour-pulse-glow {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.7; }
                }

                .tour-spotlight {
                    position: absolute;
                    pointer-events: none;
                    z-index: 1;
                    opacity: 0;
                }

                .tour-spotlight-top-left {
                    top: 0;
                    left: 0;
                    width: 291px;
                    height: 326px;
                    animation: tour-fade-in 0.6s ease-out 0s forwards, tour-pulse-glow 3s ease-in-out 2.3s infinite;
                }

                .tour-spotlight-bottom-right {
                    bottom: 0;
                    right: 0;
                    width: 291px;
                    height: 326px;
                    animation: tour-fade-in 0.6s ease-out 0.3s forwards, tour-pulse-glow 3s ease-in-out 2.3s infinite;
                }

                .tour-animated-border {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: none;
                }

                .tour-animated-border rect {
                    fill: none;
                    stroke: rgba(255, 255, 255, 0.1);
                    stroke-width: 2;
                    stroke-dasharray: 1000;
                    stroke-dashoffset: 1000;
                    animation: tour-draw-border 1.2s ease-out 1.1s forwards;
                }

                .tour-logo-animate {
                    opacity: 0;
                    animation: tour-fade-in 0.5s ease-out 0.6s forwards;
                }
            `}</style>
      <div className='fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 p-12'>
        <div className='flex w-full max-w-[720px] h-[350px] overflow-hidden rounded-12 bg-white shadow-3xl flex-col md:flex-row p-12 justify-between'>
          {/* Left Side - Content */}
          <div className='w-[380px] flex flex-col justify-center p-30'>
            <h1 className='text-24 font-bold text-neutral-80'>Hi, I&apos;m Freya</h1>
            <p className='mt-4 text-neutral-60 leading-relaxed text-14'>
              Looks like we haven&apos;t met on this device yet.
              <br />
              Take a quick tour, or skip if you&apos;re already familiar.
            </p>

            <div className='flex flex-row items-center gap-24 mt-36'>
              <button
                onClick={onStart}
                className='rounded-4 bg-primary px-16 py-6 font-medium text-white transition-colors hover:bg-green-60 whitespace-nowrap text-14'
              >
                Show Me Around
              </button>
              <button onClick={onSkip} className='font-medium text-primary transition-colors hover:text-green-60 whitespace-nowrap text-14'>
                I Know My Way
              </button>
            </div>
          </div>

          {/* Right Side - Visual */}
          <div className='relative flex w-[290px] items-center justify-center bg-[#1C2429] min-h-[200px] md:min-h-auto rounded-16 px-[28px]'>
            <div className='absolute inset-0 rounded-16 overflow-hidden'>
              {/* Grid Patterns */}
              <GridPatternTopLeft />
              <GridPatternBottomRight />

              {/* Gradient Spotlights */}
              <SpotlightTopLeft />
              <SpotlightBottomRight />
            </div>

            {/* Card Container */}
            <div className='relative z-10 flex py-16 px-30 w-full items-center justify-center rounded-24 bg-[rgba(0,0,0,0.36)] backdrop-blur-md shadow-[0_14px_34px_0_rgba(0,0,0,0.25)] overflow-hidden'>
              {/* Animated Border */}
              <AnimatedBorder />

              <div className='flex items-center gap-[17px]'>
                <img src={LogoFreya} className='tour-logo-animate w-[167px]' alt='Freya Logo' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
